"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[946],{

/***/ 9142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(9547);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ../shared/dist/contexts/Theme/index.js
var Theme = __webpack_require__(1609);
// EXTERNAL MODULE: ../shared/dist/hooks/useResize.js
var useResize = __webpack_require__(4605);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./lib/state/custom.ts
var custom = __webpack_require__(3510);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(2031);
// EXTERNAL MODULE: ./contexts/CallProvider.tsx + 1 modules
var CallProvider = __webpack_require__(6797);
// EXTERNAL MODULE: ./lib/state/core.ts
var core = __webpack_require__(8890);
;// CONCATENATED MODULE: ./components/App/Meta.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var Meta = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var callState = (0,CallProvider/* useCallState */.oz)();
    var assetPrefix = (0,config["default"])().publicRuntimeConfig.assetPrefix;
    var colors = (0,Theme.useTheme)().colors;
    var ref = _slicedToArray((0,core/* useIsMobile */.dD)(), 1), isMobile = ref[0];
    var title = (0,react.useMemo)(function() {
        switch(callState === null || callState === void 0 ? void 0 : callState.state){
            case "awaiting-args":
            case "joining":
            case "lobby":
                return t("meta.title.idle", {
                    defaultValue: "Daily | Get ready for your call",
                    fallbackLng: "en"
                });
            case "joined":
                return t("meta.title.joined", {
                    defaultValue: "Daily | You're in a call",
                    fallbackLng: "en"
                });
            case "ended":
                return t("meta.title.ended", {
                    defaultValue: "Daily |\xa0The meeting has ended",
                    fallbackLng: "en"
                });
            case "error":
                return t("meta.title.error", {
                    defaultValue: "Daily |\xa0Something went wrong",
                    fallbackLng: "en"
                });
            case "expired":
                return t("meta.title.expired", {
                    defaultValue: "Daily |\xa0This meeting is no longer available",
                    fallbackLng: "en"
                });
            case "full":
                return t("meta.title.full", {
                    defaultValue: "Daily |\xa0The meeting is full",
                    fallbackLng: "en"
                });
            case "left":
                return t("meta.title.left", {
                    defaultValue: "Daily |\xa0You have left the call",
                    fallbackLng: "en"
                });
            case "nbf":
                return t("meta.title.nbf", {
                    defaultValue: "Daily |\xa0This meeting is not available yet",
                    fallbackLng: "en"
                });
            case "not-allowed":
                return t("meta.title.notAllowed", {
                    defaultValue: "Daily | You are not allowed to join this meeting",
                    fallbackLng: "en"
                });
            case "not-found":
                return t("meta.title.notFound", {
                    defaultValue: "Daily | The meeting you're trying to join does not exist",
                    fallbackLng: "en"
                });
            case "not-secure":
                return t("meta.title.notSecure", {
                    defaultValue: "Daily | Could not connect using HTTP",
                    fallbackLng: "en"
                });
            case "removed-from-call":
                return t("meta.title.removed", {
                    defaultValue: "Daily | You were removed from the call",
                    fallbackLng: "en"
                });
        }
    }, [
        callState === null || callState === void 0 ? void 0 : callState.state,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: t("meta.og.title", {
                    defaultValue: "Join my video call",
                    fallbackLng: "en"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: "Daily"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: t("meta.og.description", {
                    defaultValue: "Just click to join this call.",
                    fallbackLng: "en"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:site",
                content: "trydaily"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: t("meta.og.title", {
                    defaultValue: "Join my video call",
                    fallbackLng: "en"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: t("meta.og.description", {
                    defaultValue: "Just click to join this call.",
                    fallbackLng: "en"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "color-scheme",
                content: "dark light"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "".concat(assetPrefix, "/apple-touch-icon.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "".concat(assetPrefix, "/favicon-32x32.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "".concat(assetPrefix, "/favicon-16x16.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "".concat(assetPrefix, "/site.webmanifest")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "mask-icon",
                href: "".concat(assetPrefix, "/safari-pinned-tab.svg"),
                color: "#5bbad5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#2b5797"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: isMobile ? (callState === null || callState === void 0 ? void 0 : callState.state) === "lobby" ? colors.background : colors.custom.mainAreaBg : colors.background
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/App/Layout.tsx
function Layout_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Layout_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Layout_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Layout_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Layout_slicedToArray(arr, i) {
    return Layout_arrayWithHoles(arr) || Layout_iterableToArrayLimit(arr, i) || Layout_unsupportedIterableToArray(arr, i) || Layout_nonIterableRest();
}
function Layout_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Layout_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Layout_arrayLikeToArray(o, minLen);
}








var Layout = function(param1) {
    var children = param1.children;
    var colors = (0,Theme.useTheme)().colors;
    var ref = Layout_slicedToArray((0,custom/* useCustomTrayButtons */.L_)(), 1), customTrayButtons = ref[0];
    /**
   * Sometimes, when rotating an iOS device, the viewport can end up being cropped,
   * because the <html>'s top position becomes negative.
   * We're going to `translateY` the app in that case, to neutralize that effect.
   */ var ref1 = (0,react.useState)(0), /*#__PURE__*/ pageOffset = ref1[0], setPageOffset = ref1[1];
    (0,useResize.useResize)((0,react.useCallback)(function() {
        var top = document.documentElement.getBoundingClientRect().top;
        setPageOffset(-1 * top);
    }, []));
    /**
   * iOS < 15 layout hack: rotating the device hides/minifies Safari's browser bars.
   * Forcing a repaint re-shows browser bars.
   */ (0,react.useEffect)(function() {
        var timeout;
        var handleOrientationChange = function() {
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                document.documentElement.style.height = "".concat(window.innerHeight, "px");
                timeout = setTimeout(function() {
                    document.documentElement.style.height = "";
                }, 0);
            }, 500);
        };
        window.addEventListener("orientationchange", handleOrientationChange);
        return function() {
            window.removeEventListener("orientationchange", handleOrientationChange);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            transform: pageOffset ? "translateY(".concat(pageOffset, "px)") : null
        },
        className: "jsx-9ef85770a31f9e5f " + styled_jsx_default().dynamic([
            [
                "9dac142235200510",
                [
                    colors.backgroundAccent,
                    colors.baseText,
                    colors.backgroundAccent,
                    colors.baseText,
                    colors.background,
                    colors.supportiveText,
                    colors.background
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: Object.entries(customTrayButtons).map(function(param) {
                    var _param = Layout_slicedToArray(param, 2), id = _param[0], btn = _param[1];
                    return(// Prefetches icons for customTrayButtons as soon as possible
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "prefetch",
                        href: btn.iconPath,
                        className: "jsx-9ef85770a31f9e5f " + styled_jsx_default().dynamic([
                            [
                                "9dac142235200510",
                                [
                                    colors.backgroundAccent,
                                    colors.baseText,
                                    colors.backgroundAccent,
                                    colors.baseText,
                                    colors.background,
                                    colors.supportiveText,
                                    colors.background
                                ]
                            ]
                        ])
                    }, id));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {}),
            children,
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "9dac142235200510",
                dynamic: [
                    colors.backgroundAccent,
                    colors.baseText,
                    colors.backgroundAccent,
                    colors.baseText,
                    colors.background,
                    colors.supportiveText,
                    colors.background
                ],
                children: ":root{--zindex-sidebar:15;--zindex-tray:10;--zindex-waitingroom:5}html{height:100%;overflow:hidden;-ms-scroll-chaining:none;overscroll-behavior:none;width:100%}body{--snackbar-info-bg:".concat(colors.backgroundAccent, ";--snackbar-info-color:").concat(colors.baseText, ";--snackbar-success-bg:").concat(colors.backgroundAccent, ";--snackbar-success-color:").concat(colors.baseText, ";height:100%;overflow:hidden;width:100%}::-webkit-scrollbar{background:").concat(colors.background, ";width:12px}::-webkit-scrollbar-thumb{background-color:").concat(colors.supportiveText, ";border:2px solid ").concat(colors.background, ";-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px}")
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "9ef85770a31f9e5f",
                children: "div.jsx-9ef85770a31f9e5f{bottom:0;left:0;overflow:hidden;position:absolute;right:0;top:0}"
            })
        ]
    });
};


/***/ }),

/***/ 6797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DG": function() { return /* binding */ CallProvider; },
  "oz": function() { return /* binding */ useCallState; }
});

// UNUSED EXPORTS: CallContext

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ../daily-react/dist/daily-react.esm.js + 1 modules
var daily_react_esm = __webpack_require__(4283);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./lib/state/custom.ts
var custom = __webpack_require__(3510);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@daily-co/daily-js/dist/daily-iframe-esm.js
var daily_iframe_esm = __webpack_require__(4061);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(2031);
;// CONCATENATED MODULE: ./contexts/useCallMachine.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





/**
 * This hook sets up the local call state machine and keeps track of the application state.
 * @param domain – The domain name.
 * @param room – The room name.
 * @param token - A meeting token for private meeting access.
 * @param customHost – Optional custom host to connect to.
 * @param isEmbedded - Whether we're running in a daily-js embedded iframe.
 */ var useCallMachine = function(param1) {
    var apiHost = param1.apiHost, bypassRegionDetection = param1.bypassRegionDetection, customHost = param1.customHost, domain = param1.domain, isEmbedded = param1.isEmbedded, micAudioMode = param1.micAudioMode, room1 = param1.room, roomsCheckOrigin = param1.roomsCheckOrigin, token = param1.token, v2CamAndMic = param1.v2CamAndMic;
    var i18n = (0,useTranslation/* useTranslation */.$)().i18n;
    var ref11 = (0,react.useState)(null), daily = ref11[0], setDaily = ref11[1];
    var ref1 = (0,react.useState)(isEmbedded ? "awaiting-args" : "ready"), state = ref1[0], setState = ref1[1];
    var ref2 = (0,react.useState)(false), closeOnLeave = ref2[0], setCloseOnLeave = ref2[1];
    var ref3 = (0,react.useState)(false), redirectOnLeave = ref3[0], setRedirectOnLeave = ref3[1];
    var wasDenied = (0,react.useRef)(false);
    var wasKnocking = (0,react.useRef)(false);
    var ref4 = (0,react.useState)(null), roomInfo = ref4[0], setRoomInfo = ref4[1];
    var ref5 = (0,react.useState)({}), callArgs = ref5[0], setCallArgs = ref5[1];
    var url1 = (0,react.useMemo)(function() {
        if (domain && room1) {
            var roomUrl = "https://".concat(customHost ? customHost : "".concat(domain, ".daily.co"), "/").concat(room1);
            var params = new URLSearchParams();
            if (customHost) {
                params.append("domain", domain);
            }
            if (bypassRegionDetection) {
                params.append("bypassRegionDetection", "true");
            }
            if (roomsCheckOrigin) {
                params.append("roomsCheckOrigin", roomsCheckOrigin);
            }
            if (apiHost) {
                params.append("apiHost", apiHost);
            }
            roomUrl = "".concat(roomUrl, "?").concat(params.toString());
            return roomUrl;
        }
        return null;
    }, [
        domain,
        room1,
        customHost,
        bypassRegionDetection,
        roomsCheckOrigin,
        apiHost, 
    ]);
    var disableAudio = (0,react.useMemo)(function() {
        return new URLSearchParams(window.location.search).get("audio") === "false";
    }, []);
    /**
   * Helper method to determine whether we want to show the prejoin UX.
   * @param co
   */ var prejoinUIEnabled = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(co) {
            var ref, ref6, ref7, ref8, room, access, ref9, ref10, prejoinEnabled, knockingEnabled;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return co.room();
                    case 3:
                        room = _ctx.sent;
                        access = co.accessState().access;
                        ;
                        prejoinEnabled = Boolean((ref10 = (ref9 = room === null || room === void 0 ? void 0 : (ref = room.tokenConfig) === null || ref === void 0 ? void 0 : ref.enable_prejoin_ui) !== null && ref9 !== void 0 ? ref9 : room === null || room === void 0 ? void 0 : (ref6 = room.config) === null || ref6 === void 0 ? void 0 : ref6.enable_prejoin_ui) !== null && ref10 !== void 0 ? ref10 : room === null || room === void 0 ? void 0 : (ref7 = room.domainConfig) === null || ref7 === void 0 ? void 0 : ref7.enable_prejoin_ui);
                        knockingEnabled = !!(room === null || room === void 0 ? void 0 : (ref8 = room.config) === null || ref8 === void 0 ? void 0 : ref8.enable_knocking);
                        return _ctx.abrupt("return", prejoinEnabled || access !== "unknown" && (access === null || access === void 0 ? void 0 : access.level) === "lobby" && knockingEnabled);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function prejoinUIEnabled(co) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Joins the call and tries to init with previously stored devices.
   * @param co – The DailyCall object.
   */ var join = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(co) {
            var ref, room;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setState("joining");
                        _ctx.next = 4;
                        return co.room();
                    case 4:
                        room = _ctx.sent;
                        // Force mute clients when joining a call with experimental_optimize_large_calls enabled.
                        if (room === null || room === void 0 ? void 0 : (ref = room.config) === null || ref === void 0 ? void 0 : ref.experimental_optimize_large_calls) {
                            co.setLocalAudio(false);
                        }
                        _ctx.next = 8;
                        return co.join({
                            subscribeToTracksAutomatically: false,
                            token: token,
                            url: url1
                        });
                    case 8:
                        setState("joined");
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(co) {
            return _ref.apply(this, arguments);
        };
    }(), [
        token,
        url1
    ]);
    /**
   * Preauthenticates, so we know about the user's access state and the room's config.
   * Puts the machine into the next state, based on access state and room config.
   * @param co – The DailyCall object.
   */ var preAuth = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(co) {
            var //@ts-ignore
            ref, //@ts-ignore
            ref12, access, room, lang, ref13, ref14, v2CamAndMicConfig;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return co.preAuth({
                            subscribeToTracksAutomatically: false,
                            token: token,
                            url: url1
                        });
                    case 3:
                        access = _ctx.sent.access;
                        _ctx.next = 6;
                        return co.room();
                    case 6:
                        room = _ctx.sent;
                        _ctx.next = 9;
                        return co.getDailyLang();
                    case 9:
                        lang = _ctx.sent.lang;
                        if ((room === null || room === void 0 ? void 0 : room.domainConfig) && room.domainConfig["attach_callobject_to_window"]) {
                            window["callObject"] = co;
                        }
                        i18n.changeLanguage(lang);
                        ;
                        v2CamAndMicConfig = (ref14 = (ref13 = (ref = callArgs.dailyConfig) === null || ref === void 0 ? void 0 : ref.v2CamAndMic) !== null && ref13 !== void 0 ? ref13 : v2CamAndMic) !== null && ref14 !== void 0 ? ref14 : room === null || room === void 0 ? void 0 : (ref12 = room.domainConfig) === null || ref12 === void 0 ? void 0 : ref12.prebuilt_v2_cam_and_mic_usage;
                        // Hacky, but again, this is only temporary while we ramp up v2 cam and
                        // mic usage for prebuilt users
                        //@ts-ignore
                        _dailyConfig.v2CamAndMic = v2CamAndMicConfig;
                        if (!(access === "unknown" || (access === null || access === void 0 ? void 0 : access.level) === "none")) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 17:
                        _ctx.t0 = (access === null || access === void 0 ? void 0 : access.level) === "lobby";
                        if (_ctx.t0) {
                            _ctx.next = 22;
                            break;
                        }
                        _ctx.next = 21;
                        return prejoinUIEnabled(co);
                    case 21:
                        _ctx.t0 = _ctx.sent;
                    case 22:
                        if (!_ctx.t0) {
                            _ctx.next = 25;
                            break;
                        }
                        setState("lobby");
                        return _ctx.abrupt("return");
                    case 25:
                        /**
       * Public room or private room with passed `token` and `enable_prejoin_ui` is `false`.
       */ join(co);
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(co) {
            return _ref.apply(this, arguments);
        };
    }(), [
        i18n,
        join,
        token,
        url1,
        callArgs,
        v2CamAndMic
    ]);
    /**
   * Sets arguments to pass to createCallObject(), and update state to indicate
   * we're ready to start.
   */ var initializeCallArgs = (0,react.useCallback)(function(args) {
        if (state !== "awaiting-args") return;
        setCallArgs(args);
        setState("ready");
    }, [
        state
    ]);
    var leave = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var accessState;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (daily) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return daily.accessState();
                case 4:
                    accessState = _ctx.sent;
                    wasKnocking.current = "awaitingAccess" in accessState;
                    // If we're in the error state, we've already "left", so just clean up
                    if (state === "error") {
                        daily.destroy();
                    } else {
                        daily.leave();
                        if (closeOnLeave) {
                            daily.destroy();
                            // Set meeting to ended state, in case window can't be closed
                            setState("ended");
                            window.close();
                        }
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        closeOnLeave,
        daily,
        state
    ]);
    /**
   * Set up the call object and preauthenticate.
   */ (0,react.useEffect)(function() {
        if (daily || !url1 || state !== "ready") return;
        if (location.protocol !== "https:" && // We want to still allow local development.
        ![
            "localhost"
        ].includes(location.hostname)) {
            setState("not-secure");
            return;
        }
        var args = _objectSpread({}, callArgs, {
            url: url1,
            dailyConfig: _objectSpread({}, callArgs.dailyConfig, {
                useDevicePreferenceCookies: true,
                // @ts-ignore
                callMode: isEmbedded ? "prebuilt-embed" : "prebuilt-direct",
                micAudioMode: micAudioMode
            }, micAudioMode !== "speech" ? {
                userMediaAudioConstraints: {
                    autoGainControl: false,
                    channelCount: micAudioMode === "music" || (micAudioMode === null || micAudioMode === void 0 ? void 0 : micAudioMode.stereo) ? 2 : 1,
                    echoCancellation: false,
                    noiseSuppression: false,
                    sampleRate: 48000,
                    sampleSize: 16
                }
            } : {})
        });
        var assetPrefix = (0,config["default"])().publicRuntimeConfig.assetPrefix;
        if (true) {
            args.dailyConfig.callObjectBundleUrlOverride = "".concat(assetPrefix, "/static/call-machine-object-bundle.js");
        } else {}
        if (disableAudio) {
            // @ts-ignore
            args.audioSource = false;
        }
        var co = daily_iframe_esm/* default.createCallObject */.ZP.createCallObject(args);
        setDaily(co);
        preAuth(co);
    }, [
        callArgs,
        daily,
        disableAudio,
        isEmbedded,
        micAudioMode,
        preAuth,
        url1,
        state,
        v2CamAndMic, 
    ]);
    /**
   * Listen for access state updates.
   */ var handleAccessStateUpdated = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
            var access, ignoreStates, meetingState;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        access = param.access;
                        ignoreStates = [
                            "ended",
                            "awaiting-args",
                            "ready"
                        ];
                        if (!ignoreStates.includes(state)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(access === "unknown" || (access === null || access === void 0 ? void 0 : access.level) === "none")) {
                            _ctx.next = 7;
                            break;
                        }
                        setState("not-allowed");
                        return _ctx.abrupt("return");
                    case 7:
                        meetingState = daily.meetingState();
                        if (!((access === null || access === void 0 ? void 0 : access.level) === "lobby" && meetingState === "joined-meeting")) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 10:
                        /**
       * 'full' access, we can now join the meeting.
       */ join(daily);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        daily,
        join,
        state
    ]);
    (0,react.useEffect)(function() {
        if (!daily || daily.isDestroyed()) return;
        daily.on("access-state-updated", handleAccessStateUpdated);
        return function() {
            daily.off("access-state-updated", handleAccessStateUpdated);
        };
    }, [
        daily,
        handleAccessStateUpdated
    ]);
    /**
   * Set up listeners for meeting state changes
   */ (0,react.useEffect)(function() {
        if (!daily || daily.isDestroyed()) return;
        var events = [
            "joined-meeting",
            "joining-meeting",
            "left-meeting",
            "error", 
        ];
        var handleMeetingState = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(ev) {
                var access, ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            access = daily.accessState().access;
                            _ctx.t0 = ev.action;
                            _ctx.next = _ctx.t0 === "joining-meeting" ? 4 : _ctx.t0 === "joined-meeting" ? 8 : _ctx.t0 === "left-meeting" ? 17 : _ctx.t0 === "error" ? 29 : 66;
                            break;
                        case 4:
                            if (!(access === "unknown" || access.level === "none" || access.level === "lobby")) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 6:
                            setState("joining");
                            return _ctx.abrupt("break", 66);
                        case 8:
                            if (!(access === "unknown" || access.level === "none" || access.level === "lobby")) {
                                _ctx.next = 10;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 10:
                            _ctx.t1 = setRoomInfo;
                            _ctx.next = 13;
                            return daily.room();
                        case 13:
                            _ctx.t2 = _ctx.sent;
                            (0, _ctx.t1)(_ctx.t2);
                            setState("joined");
                            return _ctx.abrupt("break", 66);
                        case 17:
                            daily.destroy();
                            if (!wasKnocking.current) {
                                _ctx.next = 21;
                                break;
                            }
                            setState("knocking-cancelled");
                            return _ctx.abrupt("break", 66);
                        case 21:
                            if (!wasDenied.current) {
                                _ctx.next = 24;
                                break;
                            }
                            setState("knocking-denied");
                            return _ctx.abrupt("break", 66);
                        case 24:
                            if (redirectOnLeave) {
                                _ctx.next = 27;
                                break;
                            }
                            setState("left");
                            return _ctx.abrupt("break", 66);
                        case 27:
                            setState("redirecting");
                            return _ctx.abrupt("break", 66);
                        case 29:
                            ;
                            _ctx.t3 = ev === null || ev === void 0 ? void 0 : (ref = ev.error) === null || ref === void 0 ? void 0 : ref.type;
                            _ctx.next = _ctx.t3 === "nbf-room" ? 33 : _ctx.t3 === "nbf-token" ? 33 : _ctx.t3 === "exp-room" ? 36 : _ctx.t3 === "exp-token" ? 36 : _ctx.t3 === "ejected" ? 39 : 42;
                            break;
                        case 33:
                            daily.destroy();
                            setState("nbf");
                            return _ctx.abrupt("break", 65);
                        case 36:
                            daily.destroy();
                            setState("expired");
                            return _ctx.abrupt("break", 65);
                        case 39:
                            daily.destroy();
                            setState("removed-from-call");
                            return _ctx.abrupt("break", 65);
                        case 42:
                            _ctx.t4 = ev === null || ev === void 0 ? void 0 : ev.errorMsg;
                            _ctx.next = _ctx.t4 === "Join request rejected" ? 45 : _ctx.t4 === "Meeting has ended" ? 49 : _ctx.t4 === "Meeting is full" ? 52 : _ctx.t4 === "The meeting you're trying to join does not exist." ? 55 : _ctx.t4 === "You are not allowed to join this meeting" ? 58 : 61;
                            break;
                        case 45:
                            /**
                   * Join request to a private room was denied. We can end here.
                   */ wasKnocking.current = false;
                            wasDenied.current = true;
                            daily.leave();
                            return _ctx.abrupt("break", 64);
                        case 49:
                            /**
                   * Meeting has ended or participant was removed by an owner.
                   */ daily.destroy();
                            setState("ended");
                            return _ctx.abrupt("break", 64);
                        case 52:
                            daily.destroy();
                            setState("full");
                            return _ctx.abrupt("break", 64);
                        case 55:
                            daily.destroy();
                            setState("not-found");
                            return _ctx.abrupt("break", 64);
                        case 58:
                            daily.destroy();
                            setState("not-allowed");
                            return _ctx.abrupt("break", 64);
                        case 61:
                            daily.destroy();
                            setState("error");
                            return _ctx.abrupt("break", 64);
                        case 64:
                            return _ctx.abrupt("break", 65);
                        case 65:
                            return _ctx.abrupt("break", 66);
                        case 66:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleMeetingState(ev) {
                return _ref.apply(this, arguments);
            };
        }();
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            // Listen for changes in state
            for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var event = _step.value;
                daily.on(event, handleMeetingState);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        // Stop listening for changes in state
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var event = _step.value;
                    daily.off(event, handleMeetingState);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    }, [
        daily,
        state,
        domain,
        room1,
        redirectOnLeave
    ]);
    /**
   * Listen for language changes.
   */ (0,react.useEffect)(function() {
        if (!daily || daily.isDestroyed()) return;
        var handleLangUpdated = function(event) {
            event.lang && i18n.changeLanguage(event.lang);
        };
        daily.on("lang-updated", handleLangUpdated);
        return function() {
            daily.off("lang-updated", handleLangUpdated);
        };
    }, [
        daily,
        i18n
    ]);
    (0,react.useEffect)(function() {
        var getURLWithRecentCallParam = function(url) {
            var ref = _slicedToArray(url.split("#", 2), 2), base = ref[0], hash = ref[1];
            return "".concat(base + (base.includes("?") ? "&" : "?"), "recent-call=").concat(domain, "/").concat(roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.name).concat(hash ? "#".concat(hash) : "");
        };
        var getRedirectURL = function() {
            var ref, ref18;
            if (roomInfo === null || roomInfo === void 0 ? void 0 : (ref = roomInfo.tokenConfig) === null || ref === void 0 ? void 0 : ref.redirect_on_meeting_exit) {
                var ref19;
                return getURLWithRecentCallParam(roomInfo === null || roomInfo === void 0 ? void 0 : (ref19 = roomInfo.tokenConfig) === null || ref19 === void 0 ? void 0 : ref19.redirect_on_meeting_exit);
            }
            if (roomInfo === null || roomInfo === void 0 ? void 0 : (ref18 = roomInfo.domainConfig) === null || ref18 === void 0 ? void 0 : ref18.redirect_on_meeting_exit) {
                var ref20;
                return getURLWithRecentCallParam(roomInfo === null || roomInfo === void 0 ? void 0 : (ref20 = roomInfo.domainConfig) === null || ref20 === void 0 ? void 0 : ref20.redirect_on_meeting_exit);
            }
        };
        switch(state){
            case "joined":
                var ref17, ref15, ref16;
                if (roomInfo === null || roomInfo === void 0 ? void 0 : (ref17 = roomInfo.tokenConfig) === null || ref17 === void 0 ? void 0 : ref17.close_tab_on_exit) {
                    setRedirectOnLeave(false);
                    setCloseOnLeave(true);
                } else if ((roomInfo === null || roomInfo === void 0 ? void 0 : (ref15 = roomInfo.tokenConfig) === null || ref15 === void 0 ? void 0 : ref15.redirect_on_meeting_exit) || (roomInfo === null || roomInfo === void 0 ? void 0 : (ref16 = roomInfo.domainConfig) === null || ref16 === void 0 ? void 0 : ref16.redirect_on_meeting_exit)) {
                    setRedirectOnLeave(true);
                }
                break;
            case "redirecting":
                {
                    if (isEmbedded) {
                        // Redirect to...nowhere!
                        return;
                    }
                    window.location.href = getRedirectURL();
                    break;
                }
        }
    }, [
        daily,
        domain,
        isEmbedded,
        roomInfo,
        state
    ]);
    var mode = isEmbedded ? "embedded" : "direct-link";
    return {
        daily: daily,
        disableAudio: disableAudio,
        leave: leave,
        mode: mode,
        setRedirectOnLeave: setRedirectOnLeave,
        state: state,
        initializeCallArgs: initializeCallArgs
    };
};

;// CONCATENATED MODULE: ./contexts/CallProvider.tsx
function CallProvider_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CallProvider_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function CallProvider_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function CallProvider_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CallProvider_slicedToArray(arr, i) {
    return CallProvider_arrayWithHoles(arr) || CallProvider_iterableToArrayLimit(arr, i) || CallProvider_unsupportedIterableToArray(arr, i) || CallProvider_nonIterableRest();
}
function CallProvider_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CallProvider_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CallProvider_arrayLikeToArray(o, minLen);
}





var CallContext = /*#__PURE__*/ (0,react.createContext)(null);
var CallProvider = function(param) {
    var _apiHost = param.apiHost, apiHost = _apiHost === void 0 ? null : _apiHost, _bypassRegionDetection = param.bypassRegionDetection, bypassRegionDetection = _bypassRegionDetection === void 0 ? false : _bypassRegionDetection, children = param.children, customHost = param.customHost, domain = param.domain, isEmbedded = param.isEmbedded, _micAudioMode = param.micAudioMode, micAudioMode = _micAudioMode === void 0 ? "speech" : _micAudioMode, room = param.room, _roomsCheckOrigin = param.roomsCheckOrigin, roomsCheckOrigin = _roomsCheckOrigin === void 0 ? null : _roomsCheckOrigin, _token = param.token, token = _token === void 0 ? "" : _token, v2CamAndMic = param.v2CamAndMic;
    var ref = (0,react.useState)(false), preJoinNonAuthorized = ref[0], setPreJoinNonAuthorized = ref[1];
    var ref1 = useCallMachine({
        domain: domain,
        room: room,
        token: token,
        customHost: customHost,
        isEmbedded: isEmbedded,
        bypassRegionDetection: bypassRegionDetection,
        v2CamAndMic: v2CamAndMic,
        roomsCheckOrigin: roomsCheckOrigin,
        apiHost: apiHost,
        micAudioMode: micAudioMode
    }), daily = ref1.daily, disableAudio = ref1.disableAudio, initializeCallArgs = ref1.initializeCallArgs, leave = ref1.leave, mode = ref1.mode, setRedirectOnLeave = ref1.setRedirectOnLeave, state = ref1.state;
    /**
   * Only enable the call buttons (camera toggle, leave call, etc.) if we're joined
   * or if we've errored out.
   *
   * !!!
   * IMPORTANT: calling callObject.destroy() *before* we get the "joined-meeting"
   * can result in unexpected behavior. Disabling the leave call button
   * until then avoids this scenario.
   * !!!
   */ var enableCallButtons = (0,react.useMemo)(function() {
        return [
            "joined",
            "error"
        ].includes(state);
    }, [
        state
    ]);
    var reloadCall = (0,react.useCallback)(function() {
        var url = new URL(window.location.href);
        if (!!token) {
            url.searchParams.set("t", token);
        }
        location.href = url.toString();
    }, [
        token
    ]);
    (0,react.useEffect)(function() {
        if (!daily) return;
        var access = daily.accessState().access;
        if (access === "unknown") return;
        var requiresPermission = (access === null || access === void 0 ? void 0 : access.level) === "lobby";
        setPreJoinNonAuthorized(requiresPermission && !token);
    }, [
        state,
        daily,
        token
    ]);
    var ref2 = CallProvider_slicedToArray((0,custom/* useShowLeaveButton */.Ik)(), 2), setShowLeaveButton = ref2[1];
    (0,react.useEffect)(function() {
        setShowLeaveButton(mode === "direct-link");
    }, [
        mode,
        setShowLeaveButton
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CallContext.Provider, {
        value: {
            disableAudio: disableAudio,
            enableCallButtons: enableCallButtons,
            initializeCallArgs: initializeCallArgs,
            leaveCall: leave,
            mode: mode,
            preJoinNonAuthorized: preJoinNonAuthorized,
            reloadCall: reloadCall,
            setRedirectOnLeaveCall: setRedirectOnLeave,
            state: state
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(daily_react_esm/* DailyProvider */.Eu, {
            callObject: daily,
            recoilRootProps: {
                override: false
            },
            children: children
        })
    });
};
var useCallState = function() {
    return (0,react.useContext)(CallContext);
};


/***/ }),

/***/ 8890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ew": function() { return /* binding */ useAttendeeInteractedWithUI; },
/* harmony export */   "dD": function() { return /* binding */ useIsMobile; },
/* harmony export */   "lo": function() { return /* binding */ isMobileState; },
/* harmony export */   "oS": function() { return /* binding */ useSidebarView; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);

/**
 * General UI state.
 * These are general purpose shared UI states.
 */ /**
 * Mobile state.
 * In case the user browses with a mobile device, this state enforces mobile UI
 * and overall mobile adjustments (like increased font-size and icons).
 */ var isMobileState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "is-mobile",
    default: false
});
/**
 * Returns whether this call is in mobile mode and a setter to change it.
 */ var useIsMobile = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(isMobileState);
};
var sidebarViewState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "sidebar-view",
    default: null
});
/**
 * Used to control visibility and tabs for Sidebar.
 */ var useSidebarView = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(sidebarViewState);
};
var attendeeInteractedWithUIState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "attendee-interacted-with-ui",
    default: false
});
/**
 * Returns a flag indicating whether a broadcast attendee already interacted with the UI.
 */ var useAttendeeInteractedWithUI = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(attendeeInteractedWithUIState);
};


/***/ }),

/***/ 3510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ useShowFullscreenButton; },
/* harmony export */   "Ik": function() { return /* binding */ useShowLeaveButton; },
/* harmony export */   "L_": function() { return /* binding */ useCustomTrayButtons; },
/* harmony export */   "Q1": function() { return /* binding */ useShowParticipantsBar; },
/* harmony export */   "Xn": function() { return /* binding */ useEnableJoinSound; },
/* harmony export */   "by": function() { return /* binding */ useMinGridTilesPerPage; },
/* harmony export */   "hb": function() { return /* binding */ useIsFullscreen; },
/* harmony export */   "lW": function() { return /* binding */ useMaxGridTilesPerPage; },
/* harmony export */   "sy": function() { return /* binding */ useShowLocalVideo; },
/* harmony export */   "te": function() { return /* binding */ useShowUserNameChangeUI; },
/* harmony export */   "zD": function() { return /* binding */ useShowNames; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);

/**
 * This file contains UI state that can managed from a call frame instance.
 * I.e. state that can be changed through daily-js frame methods
 */ var customTrayButtonsState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "custom-tray-buttons",
    default: {}
});
/**
 * Returns Array of custom tray buttons and a setter to change them.
 */ var useCustomTrayButtons = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(customTrayButtonsState);
};
/**
 * Call configuration states.
 */ var maxGridTilesPerPageState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "max-grid-tiles-per-page",
    default: 25
});
/**
 * Returns the maximum amount of tiles per page in grid view and a setter to change it.
 */ var useMaxGridTilesPerPage = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(maxGridTilesPerPageState);
};
var minGridTilesPerPageState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "min-grid-tiles-per-page",
    default: 1
});
/**
 * Returns the minimum amount of tiles per page in grid view and a setter to change it.
 */ var useMinGridTilesPerPage = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(minGridTilesPerPageState);
};
var showLocalVideoState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "show-local-video",
    default: true
});
/**
 * Returns a flag indicating whether the call is configured to show the local user's view
 * and a setter to change it.
 */ var useShowLocalVideo = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(showLocalVideoState);
};
var showParticipantsBarState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "show-participants-bar",
    default: true
});
/**
 * Returns a flag indicating whether to show the ParticipantBar in SpeakerView.
 */ var useShowParticipantsBar = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(showParticipantsBarState);
};
var showNamesState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "show-names",
    default: true
});
/**
 * Returns a flag indicating whether to show names on video tiles.
 */ var useShowNames = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(showNamesState);
};
var enableJoinSoundState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "enable-join-sound",
    default: true
});
/**
 * Returns a flag indicating whether to play a join sound.
 */ var useEnableJoinSound = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(enableJoinSoundState);
};
var isFullscreenState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "is-fullscreen",
    default: false
});
/**
 * Returns a flag indicating whether the call is in fullscreen mode.
 */ var useIsFullscreen = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(isFullscreenState);
};
var showLeaveButtonState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "show-leave-button",
    default: false
});
/**
 * Returns a flag indicating whether a leave button should be displayed.
 */ var useShowLeaveButton = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(showLeaveButtonState);
};
var showFullscreenButtonState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "show-fullscreen-button",
    default: false
});
/**
 * Returns a flag indicating whether a fullscreen button should be displayed.
 */ var useShowFullscreenButton = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(showFullscreenButtonState);
};
var showUserNameChangeUIState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "show-username-change-ui-state",
    default: true
});
/**
 * Returns a flag indicating whether to show the Username change UI.
 */ var useShowUserNameChangeUI = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(showUserNameChangeUIState);
};


/***/ }),

/***/ 6458:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useCardContext = exports.Card = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _useTheme2 = __webpack_require__(7039);

var _useMediaQuery = __webpack_require__(9802);

var _LoadingSpinner = __webpack_require__(3102);

var _excluded = ["appearance", "className", "children", "columns", "loading", "noBorder", "shadow", "spacing", "variant"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CardContext = /*#__PURE__*/(0, _react.createContext)({
  columns: 1
});

var useCardContext = function useCardContext() {
  return (0, _react.useContext)(CardContext);
};

exports.useCardContext = useCardContext;

var Card = function Card(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
      className = _ref.className,
      children = _ref.children,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 1 : _ref$columns,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$noBorder = _ref.noBorder,
      noBorder = _ref$noBorder === void 0 ? false : _ref$noBorder,
      _ref$shadow = _ref.shadow,
      shadow = _ref$shadow === void 0 ? 'default' : _ref$shadow,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 16 : _ref$spacing,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'small' : _ref$variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _useTheme2.useTheme)(),
      mediaQueries = _useTheme.mediaQueries;

  var spacingMap = {
    small: 16,
    large: 32
  };
  var columnsMobile = typeof columns === 'number' ? columns : columns[0];
  var columnsTablet = typeof columns === 'number' ? columns : (columns === null || columns === void 0 ? void 0 : columns[1]) || columns[0];
  var columnsDesktop = typeof columns === 'number' ? columns : (columns === null || columns === void 0 ? void 0 : columns[2]) || (columns === null || columns === void 0 ? void 0 : columns[1]) || columns[0];
  var columnsWide = typeof columns === 'number' ? columns : (columns === null || columns === void 0 ? void 0 : columns[3]) || (columns === null || columns === void 0 ? void 0 : columns[2]) || (columns === null || columns === void 0 ? void 0 : columns[1]) || columns[0];
  var isTablet = (0, _useMediaQuery.useMediaQuery)(mediaQueries.medium);
  var isDesktop = (0, _useMediaQuery.useMediaQuery)(mediaQueries.large);
  var isWide = (0, _useMediaQuery.useMediaQuery)(mediaQueries.xlarge);
  var currentColumns = isWide ? columnsWide : isDesktop ? columnsDesktop : isTablet ? columnsTablet : columnsMobile;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: _style["default"].dynamic([["3616219074", [currentColumns, spacing >= 0 ? spacing : spacingMap[variant], currentColumns > 1 ? 'row' : 'column', currentColumns > 1 ? 'wrap' : 'nowrap']]]) + " " + (props && props.className != null && props.className || (0, _classnames["default"])('card', appearance, className, "shadow-".concat(shadow), variant, {
      noBorder: noBorder
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement(CardContext.Provider, {
    value: {
      columns: currentColumns
    }
  }, children), loading && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].dynamic([["3616219074", [currentColumns, spacing >= 0 ? spacing : spacingMap[variant], currentColumns > 1 ? 'row' : 'column', currentColumns > 1 ? 'wrap' : 'nowrap']]]) + " " + "cardLoader"
  }, /*#__PURE__*/_react["default"].createElement(_LoadingSpinner.LoadingSpinner, {
    size: 24
  })), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "3616219074",
    dynamic: [currentColumns, spacing >= 0 ? spacing : spacingMap[variant], currentColumns > 1 ? 'row' : 'column', currentColumns > 1 ? 'wrap' : 'nowrap']
  }, [".card.__jsx-style-dynamic-selector{--card-columns:".concat(currentColumns, ";--card-spacing:").concat(spacing >= 0 ? spacing : spacingMap[variant], "px;border:1px solid var(--card-border);border-radius:4px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:").concat(currentColumns > 1 ? 'row' : 'column', ";-ms-flex-direction:").concat(currentColumns > 1 ? 'row' : 'column', ";flex-direction:").concat(currentColumns > 1 ? 'row' : 'column', ";-webkit-flex-wrap:").concat(currentColumns > 1 ? 'wrap' : 'nowrap', ";-ms-flex-wrap:").concat(currentColumns > 1 ? 'wrap' : 'nowrap', ";flex-wrap:").concat(currentColumns > 1 ? 'wrap' : 'nowrap', ";height:100%;overflow:hidden;position:relative;width:100%;}"), ".card.default.__jsx-style-dynamic-selector{background:var(--card-bg);}", ".card.grey.__jsx-style-dynamic-selector{background:var(--card-grey-bg);}", ".card.warning.__jsx-style-dynamic-selector{background:var(--card-warning-bg);border-color:var(--card-warning-border);}", ".noBorder.__jsx-style-dynamic-selector{border:none;}", ".shadow-default.__jsx-style-dynamic-selector{box-shadow:0px 0px 4px rgba(0,0,0,0.04), 0px 2px 2px rgba(0,0,0,0.04);}", ".shadow-strong.__jsx-style-dynamic-selector{box-shadow:0px 2px 8px rgba(0,0,0,0.2);}", ".cardLoader.__jsx-style-dynamic-selector{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:var(--card-loader-bg);border-radius:4px;bottom:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;left:0;position:absolute;right:0;top:0;}"]));
};

exports.Card = Card;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9199:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CardContent = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Card = __webpack_require__(6458);

var _excluded = ["children", "className", "footer", "header", "HrefComponent", "noDivider", "noPadding"];

var CardContent = function CardContent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? false : _ref$footer,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? false : _ref$header,
      _ref$HrefComponent = _ref.HrefComponent,
      HrefComponent = _ref$HrefComponent === void 0 ? null : _ref$HrefComponent,
      _ref$noDivider = _ref.noDivider,
      noDivider = _ref$noDivider === void 0 ? false : _ref$noDivider,
      _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useCardContext = (0, _Card.useCardContext)(),
      columns = _useCardContext.columns;

  var El = HrefComponent || (footer ? 'footer' : 'div');
  return /*#__PURE__*/_react["default"].createElement(El, (0, _extends2["default"])({}, props, {
    className: _style["default"].dynamic([["2540549756", [columns > 1 ? "flex-basis: ".concat(100 / columns, "%;") : '', columns > 1 ? 'flex-grow: 1;' : '', columns, columns, columns, columns]]]) + " " + (props && props.className != null && props.className || (0, _classnames["default"])('card-content', className, {
      footer: footer,
      header: header,
      noDivider: noDivider,
      noPadding: noPadding
    }) || "")
  }), children, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2540549756",
    dynamic: [columns > 1 ? "flex-basis: ".concat(100 / columns, "%;") : '', columns > 1 ? 'flex-grow: 1;' : '', columns, columns, columns, columns]
  }, [".card-content.__jsx-style-dynamic-selector{box-shadow:1px 0 0 var(--card-border),0 1px 0 var(--card-border);".concat(columns > 1 ? "flex-basis: ".concat(100 / columns, "%;") : '', " ").concat(columns > 1 ? 'flex-grow: 1;' : '', " flex-shrink:0;max-width:100%;min-width:calc(100% / var(--card-columns));padding:var(--card-spacing);}"), ".card-content.__jsx-style-dynamic-selector:nth-child(".concat(columns, "n+1):nth-last-child(-n + ").concat(columns, "):not(:last-child),.card-content.__jsx-style-dynamic-selector:nth-child(").concat(columns, "n+1):nth-last-child(-n + ").concat(columns, ")~.card-content.__jsx-style-dynamic-selector:not(:last-child){box-shadow:1px 0 0 var(--card-border);}"), ".card-content.__jsx-style-dynamic-selector:last-child{box-shadow:none;}", ".card-content.noPadding.__jsx-style-dynamic-selector{padding:0;}", ".header.__jsx-style-dynamic-selector{background-color:var(--card-header-bg);}", ".footer.__jsx-style-dynamic-selector{background-color:var(--card-footer-bg);}", ".header.__jsx-style-dynamic-selector,.footer.__jsx-style-dynamic-selector{max-width:none;min-width:100%;}", ".footer.__jsx-style-dynamic-selector{border-top:1px solid var(--card-border);}", "a.card-content.__jsx-style-dynamic-selector:focus-visible,a.card-content.__jsx-style-dynamic-selector:hover{background-color:var(--card-bg-hover);border-radius:0;cursor:pointer;outline:none;}"]));
};

exports.CardContent = CardContent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDYXJkQ29udGVudCIsImNoaWxkcmVuIiwiY2xhc3NOYW1lIiwiZm9vdGVyIiwiaGVhZGVyIiwiSHJlZkNvbXBvbmVudCIsIm5vRGl2aWRlciIsIm5vUGFkZGluZyIsInByb3BzIiwidXNlQ2FyZENvbnRleHQiLCJjb2x1bW5zIiwiRWwiLCJjbGFzc25hbWVzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQ2FyZC9DYXJkQ29udGVudC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGNsYXNzbmFtZXMgZnJvbSAnY2xhc3NuYW1lcyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyB1c2VDYXJkQ29udGV4dCB9IGZyb20gJy4vQ2FyZCc7XG5cbmludGVyZmFjZSBQcm9wcyBleHRlbmRzIFJlYWN0LkhUTUxBdHRyaWJ1dGVzPEhUTUxEaXZFbGVtZW50PiB7XG4gIGZvb3Rlcj86IGJvb2xlYW47XG4gIGhlYWRlcj86IGJvb2xlYW47XG4gIGhyZWY/OiBzdHJpbmc7XG4gIEhyZWZDb21wb25lbnQ/OiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxhbnk+PjtcbiAgbm9EaXZpZGVyPzogYm9vbGVhbjtcbiAgbm9QYWRkaW5nPzogYm9vbGVhbjtcbn1cblxuZXhwb3J0IGNvbnN0IENhcmRDb250ZW50OiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxQcm9wcz4+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIGNsYXNzTmFtZSxcbiAgZm9vdGVyID0gZmFsc2UsXG4gIGhlYWRlciA9IGZhbHNlLFxuICBIcmVmQ29tcG9uZW50ID0gbnVsbCxcbiAgbm9EaXZpZGVyID0gZmFsc2UsXG4gIG5vUGFkZGluZyA9IGZhbHNlLFxuICAuLi5wcm9wc1xufSkgPT4ge1xuICBjb25zdCB7IGNvbHVtbnMgfSA9IHVzZUNhcmRDb250ZXh0KCk7XG5cbiAgY29uc3QgRWwgPSBIcmVmQ29tcG9uZW50IHx8IChmb290ZXIgPyAnZm9vdGVyJyA6ICdkaXYnKTtcbiAgcmV0dXJuIChcbiAgICA8RWxcbiAgICAgIGNsYXNzTmFtZT17Y2xhc3NuYW1lcygnY2FyZC1jb250ZW50JywgY2xhc3NOYW1lLCB7XG4gICAgICAgIGZvb3RlcixcbiAgICAgICAgaGVhZGVyLFxuICAgICAgICBub0RpdmlkZXIsXG4gICAgICAgIG5vUGFkZGluZyxcbiAgICAgIH0pfVxuICAgICAgey4uLnByb3BzfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgICAgLmNhcmQtY29udGVudCB7XG4gICAgICAgICAgYm94LXNoYWRvdzogMXB4IDAgMCB2YXIoLS1jYXJkLWJvcmRlciksIDAgMXB4IDAgdmFyKC0tY2FyZC1ib3JkZXIpO1xuICAgICAgICAgICR7Y29sdW1ucyA+IDEgPyBgZmxleC1iYXNpczogJHsxMDAgLyBjb2x1bW5zfSU7YCA6ICcnfVxuICAgICAgICAgICR7Y29sdW1ucyA+IDEgPyAnZmxleC1ncm93OiAxOycgOiAnJ31cbiAgICAgICAgICBmbGV4LXNocmluazogMDtcbiAgICAgICAgICBtYXgtd2lkdGg6IDEwMCU7XG4gICAgICAgICAgbWluLXdpZHRoOiBjYWxjKDEwMCUgLyB2YXIoLS1jYXJkLWNvbHVtbnMpKTtcbiAgICAgICAgICBwYWRkaW5nOiB2YXIoLS1jYXJkLXNwYWNpbmcpO1xuICAgICAgICB9XG4gICAgICAgIC8qIFNvdXJjZTogaHR0cHM6Ly9ub3Rlc3Rvc2VsZi5kZXYvcG9zdHMvY3NzLXNlbGVjdC1sYXN0LWdyaWQtcm93LyAqL1xuICAgICAgICAuY2FyZC1jb250ZW50Om50aC1jaGlsZCgke2NvbHVtbnN9bisxKTpudGgtbGFzdC1jaGlsZCgtblxuICAgICAgICAgICAgKyAke2NvbHVtbnN9KTpub3QoOmxhc3QtY2hpbGQpLFxuICAgICAgICAuY2FyZC1jb250ZW50Om50aC1jaGlsZCgke2NvbHVtbnN9bisxKTpudGgtbGFzdC1jaGlsZCgtbiArICR7Y29sdW1uc30pXG4gICAgICAgICAgfiAuY2FyZC1jb250ZW50Om5vdCg6bGFzdC1jaGlsZCkge1xuICAgICAgICAgIGJveC1zaGFkb3c6IDFweCAwIDAgdmFyKC0tY2FyZC1ib3JkZXIpO1xuICAgICAgICB9XG4gICAgICAgIC5jYXJkLWNvbnRlbnQ6bGFzdC1jaGlsZCB7XG4gICAgICAgICAgYm94LXNoYWRvdzogbm9uZTtcbiAgICAgICAgfVxuICAgICAgICAuY2FyZC1jb250ZW50Lm5vUGFkZGluZyB7XG4gICAgICAgICAgcGFkZGluZzogMDtcbiAgICAgICAgfVxuICAgICAgICAuaGVhZGVyIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1jYXJkLWhlYWRlci1iZyk7XG4gICAgICAgIH1cbiAgICAgICAgLmZvb3RlciB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tY2FyZC1mb290ZXItYmcpO1xuICAgICAgICB9XG4gICAgICAgIC5oZWFkZXIsXG4gICAgICAgIC5mb290ZXIge1xuICAgICAgICAgIG1heC13aWR0aDogbm9uZTtcbiAgICAgICAgICBtaW4td2lkdGg6IDEwMCU7XG4gICAgICAgIH1cbiAgICAgICAgLmZvb3RlciB7XG4gICAgICAgICAgYm9yZGVyLXRvcDogMXB4IHNvbGlkIHZhcigtLWNhcmQtYm9yZGVyKTtcbiAgICAgICAgfVxuICAgICAgICBhLmNhcmQtY29udGVudDpmb2N1cy12aXNpYmxlLFxuICAgICAgICBhLmNhcmQtY29udGVudDpob3ZlciB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tY2FyZC1iZy1ob3Zlcik7XG4gICAgICAgICAgYm9yZGVyLXJhZGl1czogMDtcbiAgICAgICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgICAgICAgb3V0bGluZTogbm9uZTtcbiAgICAgICAgfVxuICAgICAgYH08L3N0eWxlPlxuICAgIDwvRWw+XG4gICk7XG59O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFFQTs7OztBQVdPLElBQU1BLFdBQXFELEdBQUcsU0FBeERBLFdBQXdELE9BUy9EO0VBQUEsSUFSSkMsUUFRSSxRQVJKQSxRQVFJO0VBQUEsSUFQSkMsU0FPSSxRQVBKQSxTQU9JO0VBQUEsdUJBTkpDLE1BTUk7RUFBQSxJQU5KQSxNQU1JLDRCQU5LLEtBTUw7RUFBQSx1QkFMSkMsTUFLSTtFQUFBLElBTEpBLE1BS0ksNEJBTEssS0FLTDtFQUFBLDhCQUpKQyxhQUlJO0VBQUEsSUFKSkEsYUFJSSxtQ0FKWSxJQUlaO0VBQUEsMEJBSEpDLFNBR0k7RUFBQSxJQUhKQSxTQUdJLCtCQUhRLEtBR1I7RUFBQSwwQkFGSkMsU0FFSTtFQUFBLElBRkpBLFNBRUksK0JBRlEsS0FFUjtFQUFBLElBRERDLEtBQ0M7O0VBQ0osc0JBQW9CLElBQUFDLG9CQUFBLEdBQXBCO0VBQUEsSUFBUUMsT0FBUixtQkFBUUEsT0FBUjs7RUFFQSxJQUFNQyxFQUFFLEdBQUdOLGFBQWEsS0FBS0YsTUFBTSxHQUFHLFFBQUgsR0FBYyxLQUF6QixDQUF4QjtFQUNBLG9CQUNFLGdDQUFDLEVBQUQsZ0NBT01LLEtBUE47SUFBQSxzREFhUUUsT0FBTyxHQUFHLENBQVYseUJBQTZCLE1BQU1BLE9BQW5DLFVBQWlELEVBYnpELEVBY1FBLE9BQU8sR0FBRyxDQUFWLEdBQWMsZUFBZCxHQUFnQyxFQWR4QyxFQXFCOEJBLE9BckI5QixFQXNCWUEsT0F0QlosRUF1QjhCQSxPQXZCOUIsRUF1QmlFQSxPQXZCakUscUVBQ2EsSUFBQUUsc0JBQUEsRUFBVyxjQUFYLEVBQTJCVixTQUEzQixFQUFzQztNQUMvQ0MsTUFBTSxFQUFOQSxNQUQrQztNQUUvQ0MsTUFBTSxFQUFOQSxNQUYrQztNQUcvQ0UsU0FBUyxFQUFUQSxTQUgrQztNQUkvQ0MsU0FBUyxFQUFUQTtJQUorQyxDQUF0QyxDQURiO0VBQUEsSUFTR04sUUFUSDtJQUFBO0lBQUEsVUFhUVMsT0FBTyxHQUFHLENBQVYseUJBQTZCLE1BQU1BLE9BQW5DLFVBQWlELEVBYnpELEVBY1FBLE9BQU8sR0FBRyxDQUFWLEdBQWMsZUFBZCxHQUFnQyxFQWR4QyxFQXFCOEJBLE9BckI5QixFQXNCWUEsT0F0QlosRUF1QjhCQSxPQXZCOUIsRUF1QmlFQSxPQXZCakU7RUFBQSwwSEFhUUEsT0FBTyxHQUFHLENBQVYseUJBQTZCLE1BQU1BLE9BQW5DLFVBQWlELEVBYnpELGNBY1FBLE9BQU8sR0FBRyxDQUFWLEdBQWMsZUFBZCxHQUFnQyxFQWR4Qyw0S0FxQjhCQSxPQXJCOUIsc0NBc0JZQSxPQXRCWixxRkF1QjhCQSxPQXZCOUIsc0NBdUJpRUEsT0F2QmpFLGd5QkFERjtBQTBERCxDQXZFTSJ9

/***/ }),

/***/ 9314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CardFooter = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _CardContent = __webpack_require__(9199);

var CardFooter = function CardFooter(props) {
  return /*#__PURE__*/_react["default"].createElement(_CardContent.CardContent, (0, _extends2["default"])({
    footer: true
  }, props));
};

exports.CardFooter = CardFooter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDYXJkRm9vdGVyIiwicHJvcHMiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9DYXJkL0NhcmRGb290ZXIudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IENhcmRDb250ZW50IH0gZnJvbSAnLi9DYXJkQ29udGVudCc7XG5cbmludGVyZmFjZSBQcm9wcyBleHRlbmRzIFJlYWN0LkNvbXBvbmVudFByb3BzPHR5cGVvZiBDYXJkQ29udGVudD4ge31cblxuZXhwb3J0IGNvbnN0IENhcmRGb290ZXI6IFJlYWN0LkZDPFJlYWN0LlByb3BzV2l0aENoaWxkcmVuPFByb3BzPj4gPSAocHJvcHMpID0+IChcbiAgPENhcmRDb250ZW50IGZvb3RlciB7Li4ucHJvcHN9IC8+XG4pO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOztBQUVBOztBQUlPLElBQU1BLFVBQW9ELEdBQUcsU0FBdkRBLFVBQXVELENBQUNDLEtBQUQ7RUFBQSxvQkFDbEUsZ0NBQUMsd0JBQUQ7SUFBYSxNQUFNO0VBQW5CLEdBQXdCQSxLQUF4QixFQURrRTtBQUFBLENBQTdEIn0=

/***/ }),

/***/ 2742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CardHeader = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _CardContent = __webpack_require__(9199);

var CardHeader = function CardHeader(props) {
  return /*#__PURE__*/_react["default"].createElement(_CardContent.CardContent, (0, _extends2["default"])({
    header: true
  }, props));
};

exports.CardHeader = CardHeader;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDYXJkSGVhZGVyIiwicHJvcHMiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9DYXJkL0NhcmRIZWFkZXIudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IENhcmRDb250ZW50IH0gZnJvbSAnLi9DYXJkQ29udGVudCc7XG5cbmludGVyZmFjZSBQcm9wcyBleHRlbmRzIFJlYWN0LkhUTUxBdHRyaWJ1dGVzPEhUTUxEaXZFbGVtZW50PiB7fVxuXG5leHBvcnQgY29uc3QgQ2FyZEhlYWRlcjogUmVhY3QuRkM8UmVhY3QuUHJvcHNXaXRoQ2hpbGRyZW48UHJvcHM+PiA9IChwcm9wcykgPT4gKFxuICA8Q2FyZENvbnRlbnQgaGVhZGVyIHsuLi5wcm9wc30gLz5cbik7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7O0FBRUE7O0FBSU8sSUFBTUEsVUFBb0QsR0FBRyxTQUF2REEsVUFBdUQsQ0FBQ0MsS0FBRDtFQUFBLG9CQUNsRSxnQ0FBQyx3QkFBRDtJQUFhLE1BQU07RUFBbkIsR0FBd0JBLEtBQXhCLEVBRGtFO0FBQUEsQ0FBN0QifQ==

/***/ }),

/***/ 8276:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CardList = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1260));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["children", "noDivider"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CardList = function CardList(_ref) {
  var children = _ref.children,
      _ref$noDivider = _ref.noDivider,
      noDivider = _ref$noDivider === void 0 ? false : _ref$noDivider,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: "jsx-602756365" + " " + (props && props.className != null && props.className || (0, _classnames["default"])('card-list', {
      noDivider: noDivider
    }) || "")
  }), _react["default"].Children.map(children, function (child) {
    var _child$props;

    return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
      className: (0, _classnames["default"])('card-list-item', (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.className)
    }));
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "602756365"
  }, [".card-list.jsx-602756365{box-shadow:1px 1px 0 var(--card-border);-webkit-flex-basis:calc(100% / var(--card-columns));-ms-flex-preferred-size:calc(100% / var(--card-columns));flex-basis:calc(100% / var(--card-columns));-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;max-width:100%;min-width:calc(100% / var(--card-columns));padding:8px 0;position:relative;}", ".card-list.noPadding.jsx-602756365{padding:0;}", ".card-list.jsx-602756365 .card-list-item{padding:12px var(--card-spacing);}", "@media (pointer:fine){.card-list.jsx-602756365 .card-list-item{padding:8px var(--card-spacing);}}"]));
};

exports.CardList = CardList;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 8257:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Card", ({
  enumerable: true,
  get: function get() {
    return _Card.Card;
  }
}));
Object.defineProperty(exports, "CardContent", ({
  enumerable: true,
  get: function get() {
    return _CardContent.CardContent;
  }
}));
Object.defineProperty(exports, "CardFooter", ({
  enumerable: true,
  get: function get() {
    return _CardFooter.CardFooter;
  }
}));
Object.defineProperty(exports, "CardHeader", ({
  enumerable: true,
  get: function get() {
    return _CardHeader.CardHeader;
  }
}));
Object.defineProperty(exports, "CardList", ({
  enumerable: true,
  get: function get() {
    return _CardList.CardList;
  }
}));

var _Card = __webpack_require__(6458);

var _CardContent = __webpack_require__(9199);

var _CardFooter = __webpack_require__(9314);

var _CardHeader = __webpack_require__(2742);

var _CardList = __webpack_require__(8276);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQ2FyZC9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBDYXJkIH0gZnJvbSAnLi9DYXJkJztcbmV4cG9ydCB7IENhcmRDb250ZW50IH0gZnJvbSAnLi9DYXJkQ29udGVudCc7XG5leHBvcnQgeyBDYXJkRm9vdGVyIH0gZnJvbSAnLi9DYXJkRm9vdGVyJztcbmV4cG9ydCB7IENhcmRIZWFkZXIgfSBmcm9tICcuL0NhcmRIZWFkZXInO1xuZXhwb3J0IHsgQ2FyZExpc3QgfSBmcm9tICcuL0NhcmRMaXN0JztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0EifQ==

/***/ }),

/***/ 7275:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Checkbox = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _Theme = __webpack_require__(1609);

var _CheckIcon = __webpack_require__(7886);

var _excluded = ["checked", "disabled", "id", "label"];

var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      id = _ref.id,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? null : _ref$label,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useTheme = (0, _Theme.useTheme)(),
      colors = _useTheme.colors,
      fontFamilies = _useTheme.fontFamilies;

  var isControlled = typeof checked === 'boolean';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].dynamic([["332686662", [label ? '24px' : '16px', fontFamilies.medium]]])
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    checked: checked,
    disabled: disabled,
    id: id,
    type: "checkbox"
  }, props, {
    className: _style["default"].dynamic([["332686662", [label ? '24px' : '16px', fontFamilies.medium]]]) + " " + (props && props.className != null && props.className || (0, _classnames["default"])({
      isControlled: isControlled,
      checked: checked
    }) || "")
  })), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id,
    className: _style["default"].dynamic([["332686662", [label ? '24px' : '16px', fontFamilies.medium]]])
  }, label), /*#__PURE__*/_react["default"].createElement(_CheckIcon.CheckIcon, {
    className: "checkIcon",
    color: disabled ? colors.supportiveText : 'currentColor',
    size: 16
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "332686662",
    dynamic: [label ? '24px' : '16px', fontFamilies.medium]
  }, ["div.__jsx-style-dynamic-selector{position:relative;}", "input.__jsx-style-dynamic-selector{opacity:0;position:absolute;}", "label.__jsx-style-dynamic-selector{cursor:pointer;display:inline-block;padding-left:".concat(label ? '24px' : '16px', ";-webkit-tap-highlight-color:rgba(0,0,0,0);}"), "label.__jsx-style-dynamic-selector::before{background:var(--input-bg);border:1px solid var(--radio-border);border-radius:4px;box-shadow:0 0 0 0 var(--focus-shadow);content:'';height:16px;left:0;position:absolute;top:1px;-webkit-transition:border 200ms ease,box-shadow 200ms ease;transition:border 200ms ease,box-shadow 200ms ease;width:16px;}", "input.__jsx-style-dynamic-selector~.checkIcon{left:0;opacity:0;pointer-events:none;position:absolute;top:1px;-webkit-transition:opacity 200ms ease;transition:opacity 200ms ease;}", ".isControlled.checked.__jsx-style-dynamic-selector+label.__jsx-style-dynamic-selector,input.__jsx-style-dynamic-selector:not(.isControlled):checked+label.__jsx-style-dynamic-selector{font-family:".concat(fontFamilies.medium, ";font-weight:normal;}"), ".isControlled.checked.__jsx-style-dynamic-selector~.checkIcon,input.__jsx-style-dynamic-selector:not(.isControlled):checked~.checkIcon{opacity:1;}", "input.__jsx-style-dynamic-selector:not([disabled])+label.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector::before,div.__jsx-style-dynamic-selector:focus-within label.__jsx-style-dynamic-selector::before{border-color:var(--focus-border);box-shadow:0 0 0 2px var(--focus-shadow);}", "input[disabled].__jsx-style-dynamic-selector+label.__jsx-style-dynamic-selector{color:var(--text-muted);cursor:default;}", "input[disabled].__jsx-style-dynamic-selector+label.__jsx-style-dynamic-selector::before{opacity:0.6;}"]));
};

exports.Checkbox = Checkbox;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 8889:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Checkbox", ({
  enumerable: true,
  get: function get() {
    return _Checkbox.Checkbox;
  }
}));

var _Checkbox = __webpack_require__(7275);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQ2hlY2tib3gvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgQ2hlY2tib3ggfSBmcm9tICcuL0NoZWNrYm94JztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 1937:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Form = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _excluded = ["children", "className", "onSubmit"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Form = function Form(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onSubmit = _ref.onSubmit,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var formRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hasSubmitted = _useState2[0],
      setHasSubmitted = _useState2[1];

  var handleSubmit = function handleSubmit(ev) {
    ev.preventDefault();
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(ev);
  };

  var handleSubmitButtonClick = function handleSubmitButtonClick(ev) {
    var _formRef$current;

    var target = ev.target;

    if ((target === null || target === void 0 ? void 0 : target.type) === 'submit' && (formRef.current.contains(target) || (target === null || target === void 0 ? void 0 : target.getAttribute('form')) === ((_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.id))) {
      setHasSubmitted(true);
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleSubmitButtonClick);
    return function () {
      document.removeEventListener('click', handleSubmitButtonClick);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("form", (0, _extends2["default"])({
    ref: formRef,
    className: (0, _classnames["default"])(className, {
      submitted: hasSubmitted
    }),
    onSubmit: handleSubmit
  }, props), children);
};

exports.Form = Form;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 7509:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "l", ({
  enumerable: true,
  get: function get() {
    return _Form.Form;
  }
}));

var _Form = __webpack_require__(1937);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRm9ybS9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBGb3JtIH0gZnJvbSAnLi9Gb3JtJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 4605:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useResize = void 0;

var _react = __webpack_require__(7294);

/**
 * Accepts a stable function reference to be called on window.resize
 * and window.orientationchange events.
 * useResize calls the function once initially.
 */
var useResize = function useResize(callback) {
  (0, _react.useEffect)(function () {
    var frame;

    var handleResize = function handleResize() {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        return callback();
      });
    };

    window.addEventListener('resize', handleResize, {
      passive: true
    });
    window.addEventListener('orientationchange', handleResize, {
      passive: true
    });
    callback();
    return function () {
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [callback]);
};

exports.useResize = useResize;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ })

}]);